import React, { useEffect, useState } from 'react';
import { Box, Button, Grid, Card, CardContent, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { styles } from './styles';
import DepartmentDetailsTab from '../../../features/departments/DepartmentDetailsTab';
import { useNewDepartmentMutation, useModifyDepartmentMutation } from '../../../api/departments';

const AddEditDepartment = (props) => {
    const params = useParams();
    const [departmentDetails, setDepartmentDetails] = useState({});
    const location = useLocation();
    const isEditMode = location.pathname.includes('edit');
    const navigate = useNavigate();

    const { enqueueSnackbar } = useSnackbar();
    const [newDepartment, { isLoading: isNewLoading }] = useNewDepartmentMutation();
    const [modifyDepartment, { isLoading: isModifyLoading }] = useModifyDepartmentMutation();

    const isLoading = isNewLoading || isModifyLoading;

    useEffect(() => {
        const fetchData = async () => {
            const bodyFormData = new FormData();
            try {
                let response;
                if (isEditMode) {
                    bodyFormData.append('id', params.id);
                    response = await modifyDepartment(bodyFormData).unwrap();
                } else {
                    response = await newDepartment(bodyFormData).unwrap();
                }
                if (!response) return;
                if (response?.status === 'ERROR') throw new Error(response?.message);
                setDepartmentDetails(response);
            } catch (err) {
                if (err?.statusCode === 400) enqueueSnackbar(err?.data?.message, { variant: 'error' });
                else enqueueSnackbar(err?.message || 'Something went wrong!', { variant: 'error' });
            }
        };

        fetchData();
    }, [params.id, isEditMode, newDepartment, modifyDepartment, enqueueSnackbar]);

    return (
        <Box>
            <Box sx={styles.contentHeaderWrapper}>
                <Typography variant="h4">{isEditMode ? 'Edit Department' : 'Add Department'}</Typography>
            </Box>
            <Box sx={styles.contentBodyWrapper}>
                <Card {...props}>
                    <CardContent>
                        <Grid container direction="column" spacing={2}>
                            <Grid item>
                                <Button
                                    startIcon={<ChevronLeftIcon />}
                                    variant="text"
                                    color="secondary"
                                    onClick={() => navigate('/settings/departments')}
                                >
                                    Back
                                </Button>
                            </Grid>
                        </Grid>
                        <Grid
                            item
                            sx={{
                                pt: 1,
                            }}
                        >
                            <DepartmentDetailsTab
                                isEditMode={isEditMode}
                                departmentDetails={departmentDetails}
                                isLoading={isLoading}
                            />
                        </Grid>
                    </CardContent>
                </Card>
            </Box>
        </Box>
    );
};

export default AddEditDepartment;
